<template>
	<div class="grouped_recommended font-responsive" >
		<component v-if="activeGroup && activeGroupName" :is="'RecommendedProducts'" :component_data="activeGroup"
			:key="string_to_slug(activeGroupName)">
			<template slot="subheader">
				<ul class="grouped_recommended_nav">
					<li v-for="(group, key) in groupedProducts" :key="key+'nav'" :class="{'active_group': activeGroupName==key}"
						@click="activeGroup=group;activeGroupName=key">{{key}}</li>
				</ul>
			</template>
		</component>
	</div>
</template>

<script>
	import RecommendedProducts from '@/components/RecommendedProducts/RecommendedProducts'

	export default {
		data() {
			return {
				activeGroup: [],
				activeGroupName: ''
			}
		},
		components: {
			'RecommendedProducts': RecommendedProducts
		},
		props: {
			'component_data': {
				default: () => []
			}
		},
		computed: {
			// zwraca listę produktów polecanych ustawionych dla komponentu lub w głównej tablicy parametrów lp'ka
			productsData() {
				if (this.component_data.length) {
					return this.component_data
				}
				if (window.pageContentData) {
					return window.pageContentData.params.recommendedProducts
				}
				return []
			},
			groupedProducts() {
				let groups = {}
				this.productsData.forEach(element => {
					if (element.displayGroup) {
						if (!groups[element.displayGroup]) {
							groups[element.displayGroup] = []
						}
						groups[element.displayGroup].push(element)
					} else {
						if (!groups['other']) {
							groups['other'] = []
						}
						groups['other'].push(element)
					}
				});
				return groups;
			}
		},
		methods: {
			string_to_slug(str) {
				console.log(str)
				str = str.replace(/^\s+|\s+$/g, ''); // trim
				str = str.toLowerCase();

				// remove accents, swap ñ for n, etc
				var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
				var to = "aaaaaeeeeiiiioooouuuunc------";

				for (var i = 0, l = from.length; i < l; i++) {
					str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
				}

				str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
					.replace(/\s+/g, '-') // collapse whitespace and replace by -
					.replace(/-+/g, '-'); // collapse dashes

				return str;
			}
		},
		mounted() {
			let firstGroup = Object.keys(this.groupedProducts)[0]
			console.log(firstGroup)
			this.activeGroup = this.groupedProducts[firstGroup]
			this.activeGroupName = firstGroup
			console.log(this.activeGroupName)
		}
	}
</script>

<style>
	.grouped_recommended {
		width: 100%;
		position: relative;
	}

	.grouped_recommended::before {
		content: '';
		position: absolute;
		height: 19em;
		top: -5em;
		width: 100%;
		background-color: #FAF9F7;
	}

	.grouped_recommended_nav {
		list-style: none;
		display: flex;
		justify-content: flex-end;
		margin: 0 0 0 auto;
	}

	.grouped_recommended_nav li {
		display: inline-block;
		background-color: #FAF9F7;
		color: #E41429;
		font-family: 'Lato', sans-serif;
		font-weight: 700;
		border: #E41429 1px solid;
		border-radius: 100em;
		font-size: 14px;
		padding: 10px 25px;
		text-transform: uppercase;
		margin-left: 30px;
		z-index: 20;
		cursor: pointer;
	}

	@media (max-width: 1080px) {
		.grouped_recommended .recommended_products_header {
			flex-wrap: wrap;
		}

		.grouped_recommended h2.section-heading {
			min-width: 100%;
		}

		.grouped_recommended_nav {
			flex-wrap: wrap;
			justify-content: space-around;
			margin: 2.5em 0;
			padding: 0;
			width: 100%;
		}

		.grouped_recommended_nav li {
			margin: 1em 0;
		}
	}

	.grouped_recommended_nav li.active_group {
		background: linear-gradient(to right, #E41429, #AE0B11);
		color: #FFE3E3;

	}
</style>